import { render, staticRenderFns } from "./Bor.vue?vue&type=template&id=0810e80d&"
import script from "./Bor.vue?vue&type=script&lang=js&"
export * from "./Bor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports